import { SVG } from '../svg';
import { IconProps } from '../types';

export function ZeroDataIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <circle cx="12" cy="12" r="10" />
      <path d="M22 2 2 22" />
    </SVG>
  );
}
